export default "__VITE_ASSET__XR6w$jeg__"